


































































import {
  EmailFiltro,
  EmailService,
  FiltroEmail,
} from "@/services/email.service";
import { required } from "@/shared/validators";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import ComboFiltroEmail, { ResultEvent } from "./ComboFiltroEmail.vue";

class FiltroForm implements EmailFiltro {
  // 0 = "Editar query" no ComboFiltroEmail (abre o editor de query por padrão)
  filtro: FiltroEmail | number = 0;
  query = "";
}

@Component({
  components: { ComboFiltroEmail },
})
export default class FiltroEmailComponent extends Vue {
  //Atributos
  data: EmailFiltro = new FiltroForm();
  exibirEditorQuery = false;
  resultados: number | null | undefined = null;
  rules = {
    query: [] as any[],
  };

  //Props
  @Prop() readonly value!: EmailFiltro;

  //Métodos
  mounted() {
    this.onChange(this.value);
  }

  @Watch("value")
  onChange(val: EmailFiltro | null | undefined) {
    if (val) this.data = val;
    this.emitir();
  }

  emitir() {
    this.$emit("input", this.data);
  }

  /**
   * Observa o evento de resultados no componente combo de filtros
   */
  async onResults(event: ResultEvent) {
    this.data.query = "";
    this.exibirEditorQuery = event.exibirQueryEditor;

    if (event.results) this.resultados = await event.results;
    else this.resultados = event.results;

    this.updateValidacao();
  }

  updateValidacao() {
    if (this.exibirEditorQuery) this.rules.query = [required()];
    else this.rules.query = [];
  }

  async verificaQuery() {
    if (this.data.query) {
      this.resultados = await EmailService.obterQuantidadeConsultor(
        this.data.query
      );
    } else {
      this.resultados = null;
    }
  }

  reset(){
    this.onChange(new FiltroForm());
  }
}
